module.exports = __webpack_public_path__ + "009917415656c58e0fe93f3dc03314c9.svg";